import { render, staticRenderFns } from "./BadGateway.vue?vue&type=template&id=c7dfb7cc&scoped=true&"
import script from "./BadGateway.vue?vue&type=script&lang=js&"
export * from "./BadGateway.vue?vue&type=script&lang=js&"
import style0 from "./BadGateway.vue?vue&type=style&index=0&id=c7dfb7cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dfb7cc",
  null
  
)

export default component.exports